<template>
<div class="c-social c-home c-home--has-grid">
    <GridBackground />
    <div class="c-social__slider">
        <slick class="c-social__list" v-if="social_content" :options="slick_options" ref="slick">
            <div class="c-social__item" v-for="(item,index) in social_content" :key="index">
                <div v-if="('text' in item)">
                    <div class="c-social__body">
                        <div class="c-social__user flex flex-align-center">
                            <div class="c-social__user-image">
                                <img :src="item.user.image" :alt="item.user.name"/>
                            </div>
                            <div class="c-social__user-handle">
                                <a class="c-social__user-url" :href="'https://twitter.com/' + item.user.screen_name" target="_blank">{{ '@' + item.user.screen_name}}</a>
                            </div>
                            <div class="c-social__icon c-social__icon--twitter">
                                <span class="feather icon-twitter"></span>
                            </div>
                        </div>
                        <div v-if="item.text" class="c-social__text" v-html="item.text"></div>
                    </div>
                    <div class="c-social__media-container">
                        <a :href="'https://www.twitter.com/' + item.user.screen_name + '/status/' + item.id" title="View on Twitter" target="_blank">
                        <div v-if="item.media && $mq == 'sm'" class="c-social__media--mobile" >
                            <img :src="item.media" alt="twitter"/>
                        </div>
                        <div v-if="item.media && $mq != 'sm'" class="c-social__media" :style="{backgroundImage: 'url(' + item.media + ')'}">
                        </div>
                        </a>
                    </div>
                </div>
                <div v-if="!('text' in item)">
                    <div class="c-social__body">
                        <div class="c-social__user flex flex-align-center">
                            <div class="c-social__user-image">
                                <img :src="item.user.profile_picture" :alt="item.user.full_name"/>
                            </div>
                            <div class="c-social__user-handle">
                                <a class="c-social__user-url" :href="'https://instagram.com/' + item.user.username" target="_blank">{{ '@' + item.user.username}}</a>
                            </div>
                            <div class="c-social__icon c-social__icon--instagram">
                                <span class="feather icon-instagram"></span>
                            </div>
                        </div>
                        <div v-if="item.caption.text" class="c-social__text">{{ item.caption.text }}</div>
                    </div>
                    <div class="c-social__media-container">
                        <a :href="item.link" title="View on Instagram" target="_blank">
                        <div v-if="$mq == 'sm'" class="c-social__media--mobile" >
                            <img :src="item.images.standard_resolution.url" alt="instagram"/>
                        </div>
                        <div v-if="$mq != 'sm'" class="c-social__media" :style="{backgroundImage: 'url(' + item.images.standard_resolution.url + ')'}">
                        </div>
                        </a>
                    </div>
                </div>
            </div>
        </slick>
    </div>
    <GlitchText :text="glitch_text"/>
</div>
</template>

<script>
import axios from 'axios'
import Slick from 'vue-slick'
import '../../node_modules/slick-carousel/slick/slick.css'
import _ from 'lodash'
import GridBackground from '@/components/GridBackground'
import GlitchText from '@/components/GlitchText.vue'

export default {
    name: 'HomeSocial',

    components: {
        Slick,
        GridBackground,
        GlitchText
    },

    data: () => ({
        social_content: [],
        slick_options: {
            slidesToShow: 1,
            slidesToScroll:1
        },
        glitch_text: '#GEAUXTIGERS'
    }),

    methods: {
        get_data() {
            let twitterPromise =  new Promise((resolve) => {
                axios.get('/services/featurepage.ashx?type=get-tweets&twitter=LSUfootball&take=5&sport_id=24')
                .then(response => {
                   resolve(response.data);
                });
            });

            let instagramPromise =  new Promise((resolve) => {
                axios.get('/services/featurepage.ashx?type=get-instagrams&instagram=lsufootball&take=5&sport_id=24')
                .then(response => {
                    resolve(response.data);
                });
            });

            Promise.all([twitterPromise, instagramPromise]).then(values => {
                
                let combinedContent = [];

                combinedContent = _.flatten(values);

                combinedContent = _.sortBy(combinedContent, [function(o){return o.date;}]);
                
                this.social_content = combinedContent;
            });
        }
    },

    created() {
        this.get_data();
    },

    watch: {
            social_content: function () {

            this.$refs.slick.destroy()
            
            this.$nextTick(() => {
                this.$refs.slick.create()
            });
        }
    }
}
</script>

<style lang="scss">
    @import "../styles/imports";

    .c-social{
        display: block;
        position:relative;
        z-index:2;
        width:100vw;
        button.slick-prev, button.slick-next{
            @include appearance;
            position: absolute;
            bottom:0;
            color:$white;
            z-index: 10;
            width: 48px;
            height: 48px;
            font-size: 0;
            left:12px;
            &::after{
                position: absolute;
                top: 50%;
                left:50%;
                font-family: 'feather';
                content:'\e828';
                font-size: 24px;
                color:$white;
                @include transform(translate(-50%,-50%));
                transition: 0.2s;
            }
            &:hover{
                cursor: pointer;
                &::after{
                    color: $gold;
                }
            }
        }
        button.slick-next{
            left:auto;
            right:12px;
            
            &::after{
                content:'\e829';
            }
        }
    }
    .c-social__slider{
        display: block;
        width: 100%;
        overflow: hidden;
    }
    .c-social__list{
        width:100%;
        padding-bottom:48px;
        margin: 0 auto;
    }

    .c-social__item{
        padding:0;
        transition:0.2s;
        min-height:calc(100vw * 0.6 * 0.33333 * 0.5625 * 3);
        pointer-events:none;
    }
    .slick-active{
        .c-social__item{
        pointer-events:all;
        }
        .c-social__user{
            opacity:1;
        }
        .c-social__icon{
            opacity:1;
        }
        .c-social__text{
            opacity:1;
        }
        .c-social__media{
            background-position:top left;
            opacity:1;
            height:calc(100vw * 0.6 * 0.33333 * 0.5625 * 2);
        }
        .c-social__media--mobile{
            opacity:1;
            @include transform(none);
        }
        & + .slick-slide{
            .c-social__media{
                background-position:top left;
            }
        }
    }

    .c-social__body{
        min-height:calc(100vw * 0.6 * 0.33333 * 0.5625);
    }

    .c-social__user{
        padding: 24px;
        opacity:0;
        transition:0.3s;
        &-image{
            width:48px;
            height:48px;
            @include flex-item(0 0 auto);
            overflow:hidden;
            border:solid 2px $white;
            border-radius:50%;
            margin-right:24px;
            img{
                width:100%;
            }
        }
        &-url{
            @include flex-item(0 1 auto);
            text-decoration: none;
            color: $white;
            font-weight:400;
            font-size: 1rem;
            letter-spacing: 0.08rem;
            transition:0.2s;
            &:hover{
                color:$gold;
            }
        }
    }
    .c-social__icon{
        align-self:flex-start;
        margin-left:auto;
        color:#EB5757;
        font-size: 24px;
        opacity:0;
        transition:0.3s;
        &--twitter{
            color:#2F80ED;
        }
    }
    .c-social__text{
        padding:0 24px 24px;
        opacity:0;
        transition:0.3s;
    }
    .c-social__media-container{
    }
    .c-social__media{
        background: top right no-repeat;
        background-size: contain;
        height:calc(100vw * 0.6 * 0.33333 * 0.5625);
        opacity:0.5;
        transition:0.4s;
    }
    .c-social__media--mobile{
        padding:0 24px 24px;
        opacity:0;
        @include transform(translateY(-20%));
        transition:opacity 0.3s 0.3s, transform 0.3s 0.3s;
        position:relative;
        overflow:hidden;
        height:35vh;
        img{
            max-height:100%;
            object-fit:contain;
        }
    }

    @media all and (min-width:$small-breakpoint){
        .c-social{
            button.slick-prev,button.slick-next{
                bottom:auto;
                top:50%;
            left:-33.3333%;
             @include transform(tranlate(48px,-50%));
            }
            button.slick-next{
                left:auto;
                right:-33.3333%;
                @include transform(translate(-48px,-50%));
            }

        }
        .c-social__slider{
            padding:0;
        }
        .c-social__list{
            width:60%;
            padding-bottom:0;
            .slick-list{
                overflow:visible;
            }
        }
        .c-social__user{
            &-image{
                width:72px;
                height:72px;
            }
            &-url{
                font-size:1.5rem;
                letter-spacing:0.08rem;
                letter-spacing: 0.08rem;
            }
        }
    }
</style>